import React, { useState } from 'react';
import { usePopper } from 'react-popper';

import styled from 'styled-components';
import ProductContent from '../ProductContent/ProductContent';

const HoverBubble = props => {
  const { annotation, imageId } = props;
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const [arrowElement, setArrowElement] = useState(null);
  const [popupActive, setPopupActive] = useState(true);
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: 'top',
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 5]
        }
      },
      {
        name: 'arrow',
        options: {
          element: arrowElement,
          padding: 8
        }
      },
      {
        name: 'flip',
        enabled: false
      },
      {
        name: 'preventOverflow',
        options: {
          boundary: document.querySelector(`#image-annotation-${imageId}`),
          altBoundary: true,
          padding: 5
        }
      }
    ]
  });

  if (!annotation || !annotation.product) {
    return null;
  }

  return (
    <Container
      onMouseEnter={() => setPopupActive(true)}
    >
      <div
        className="locator-reference"
        ref={setReferenceElement}
        style={{
          top: `calc(${annotation.yCoordinate * 100}%)`,
          left: `calc(${annotation.xCoordinate * 100}%)`
        }}
        {...attributes.reference}
      />
      {popupActive && (
        <div
          className="popup"
          ref={setPopperElement}
          style={styles.popper}
          {...attributes.popper}
        >
          <div className="drop-shadow">
            <div
              className="arrow"
              ref={setArrowElement}
              style={{
                ...styles.arrow,
                transform: `${styles.arrow.transform} rotate(45deg)`
              }}
            />
            <ProductContent product={annotation.product} />
          </div>
        </div>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: block;

  .locator-reference {
    display: block;
    position: absolute;
  }

  .popup {
    padding: 14px 0;
    position: absolute;
    z-index: 1001;
    bottom: 6px !important;
  }

  .drop-shadow {
    border-radius: 8px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    position: relative;
    display: block;
    z-index: 0;
  }

  .arrow {
    background-color: white;
    bottom: -6px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    clear: both;
    content: '';
    display: block;
    height: 14px;
    left: 0;
    position: absolute;
    width: 14px;
    z-index: -1;
  }
`;

export default HoverBubble;
